
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","version":"1.0","width":"64","height":"64","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('g',[_c('path',{attrs:{"d":"M59.6 0h8v40h-8V0z","fill":"#1f54a3"}}),_c('path',{attrs:{"d":"M92.19 6.374l6.928 4-20 34.641-6.929-4 20-34.64zM117.226 28.19l4 6.928-34.641 20-4-6.929 34.64-20zM128 59.6v8H88v-8h40zM121.626 92.19l-4 6.928-34.641-20 4-6.929 34.64 20z","fill":"#d2dded","fill-opacity":".2"}}),_c('path',{attrs:{"d":"M99.81 117.226l-6.928 4-20-34.641 6.929-4 20 34.64z","fill":"#bbcbe3","fill-opacity":".3"}}),_c('path',{attrs:{"d":"M68.4 128h-8V88h8v40z","fill":"#a5bbda","fill-opacity":".4"}}),_c('path',{attrs:{"d":"M35.81 121.626l-6.928-4 20-34.641 6.929 4-20 34.64z","fill":"#8fa9d1","fill-opacity":".5"}}),_c('path',{attrs:{"d":"M10.774 99.81l-4-6.928 34.641-20 4 6.929-34.64 20z","fill":"#7998c8","fill-opacity":".6"}}),_c('path',{attrs:{"d":"M0 68.4v-8h40v8H0z","fill":"#6287be","fill-opacity":".7"}}),_c('path',{attrs:{"d":"M6.374 35.81l4-6.928 34.641 20-4 6.929-34.64-20z","fill":"#4c76b5","fill-opacity":".8"}}),_c('path',{attrs:{"d":"M28.19 10.774l6.928-4 20 34.641-6.929 4-20-34.64z","fill":"#3565ac","fill-opacity":".9"}}),_c('animateTransform',{attrs:{"attributeName":"transform","type":"rotate","values":"0 64 64;30 64 64;60 64 64;90 64 64;120 64 64;150 64 64;180 64 64;210 64 64;240 64 64;270 64 64;300 64 64;330 64 64","calcMode":"discrete","dur":"1080ms","repeatCount":"indefinite"}})])])
          )
        }
      }
    